import { Button, Flex, Select } from '@mantine/core'
import { FormattedMessage, useIntl } from 'react-intl'
import {
  DEFAULT_FILTERS,
  DateRangeOption,
  VlmResultsFilterState
} from './vlmResultsFilterConfig'

type VlmResultsFiltersProps = {
  filters: VlmResultsFilterState
  onFiltersChange: (filters: VlmResultsFilterState) => void
}

export const VlmResultsFilters = ({
  filters,
  onFiltersChange
}: VlmResultsFiltersProps) => {
  const intl = useIntl()

  const dateRangeOptions = [
    {
      value: 'all',
      label: intl.formatMessage({ id: 'vlm.results.filter.allTime' })
    },
    {
      value: '1h',
      label: intl.formatMessage({ id: 'vlm.results.filter.last1Hour' })
    },
    {
      value: '24h',
      label: intl.formatMessage({ id: 'vlm.results.filter.last24Hours' })
    },
    {
      value: '7d',
      label: intl.formatMessage({ id: 'vlm.results.filter.last7Days' })
    }
  ]

  const isFiltered = filters.dateRange !== 'all'

  return (
    <Flex align="center" gap="xs">
      <Select
        size="xs"
        w={160}
        data={dateRangeOptions}
        value={filters.dateRange}
        allowDeselect={false}
        onChange={(value) =>
          value &&
          onFiltersChange({ ...filters, dateRange: value as DateRangeOption })
        }
      />
      {isFiltered && (
        <Button
          size="xs"
          variant="subtle"
          onClick={() => onFiltersChange(DEFAULT_FILTERS)}
        >
          <FormattedMessage id="general.clearFilters" />
        </Button>
      )}
    </Flex>
  )
}
